export const state = () => ({
  schools: [],
  currentSchool: null,
  loading: false,
  error: null,
  pagination: {
    page: 0,
    size: 10,
    totalElements: 0,
    totalPages: 0
  }
})

export const getters = {
  schools: (state) => state.schools,
  currentSchool: (state) => state.currentSchool,
  loading: (state) => state.loading,
  error: (state) => state.error,
  pagination: (state) => state.pagination
}

export const mutations = {
  SET_LOADING(state, loading) {
    state.loading = loading
  },
  SET_ERROR(state, error) {
    state.error = error
  },
  SET_SCHOOLS(state, data) {
    if (data.content) {
      state.schools = data.content
      state.pagination = {
        page: data.number,
        size: data.size,
        totalElements: data.totalElements,
        totalPages: data.totalPages
      }
    } else {
      state.schools = Array.isArray(data) ? data : []
    }
  },
  SET_CURRENT_SCHOOL(state, school) {
    state.currentSchool = school
  },
  ADD_SCHOOL(state, school) {
    state.schools.push(school)
  },
  UPDATE_SCHOOL(state, school) {
    const index = state.schools.findIndex(s => s.id === school.id)
    if (index !== -1) {
      state.schools.splice(index, 1, school)
    }
  },
  REMOVE_SCHOOL(state, schoolId) {
    state.schools = state.schools.filter(s => s.id !== schoolId)
  }
}

export const actions = {
  async fetchSchools({ commit }, { page = 0, size = 10, sortBy = 'name', direction = 'asc' } = {}) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      const response = await this.$axios.get('/auth/api/school', {
        params: { page, size, sortBy, direction }
      })
      commit('SET_SCHOOLS', response.data)
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Failed to fetch schools')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async fetchSchool({ commit }, schoolId) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      const response = await this.$axios.get(`/auth/api/school/${schoolId}`)
      commit('SET_CURRENT_SCHOOL', response.data)
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Failed to fetch school')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async createSchool({ commit }, schoolData) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      const response = await this.$axios.post('/auth/api/school', schoolData)
      commit('ADD_SCHOOL', response.data)
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Failed to create school')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async updateSchool({ commit }, { schoolId, schoolData }) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      const response = await this.$axios.put(`/auth/api/school/${schoolId}`, schoolData)
      commit('UPDATE_SCHOOL', response.data)
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Failed to update school')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async deleteSchool({ commit }, schoolId) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      await this.$axios.delete(`/auth/api/school/${schoolId}`)
      commit('REMOVE_SCHOOL', schoolId)
      return true
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Failed to delete school')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  },

  async assignUserToSchool({ commit }, { userId, schoolId }) {
    commit('SET_LOADING', true)
    commit('SET_ERROR', null)
    try {
      const response = await this.$axios.put(`/auth/api/user/${userId}/assign-school/${schoolId}`)
      return response.data
    } catch (error) {
      commit('SET_ERROR', error.response?.data?.message || 'Failed to assign user to school')
      throw error
    } finally {
      commit('SET_LOADING', false)
    }
  }
}

